import ModalContainer from './ModalContainer';
export * from './ModalContainer';

export default ModalContainer;
